<template>
  <main id="main">
    <Loading :isProcessing="isProcessing"></Loading>
    <div class="l-contents" v-if="!isRendering">
      <h1 class="l-pageTitle"><img src="@/assets/img/common/icon-nav3_blue.svg" alt="">お問い合わせ</h1>
      <div class="l-btn-createnew_pos">
        <div class="btn-create-new_wh" @click="goInput('')" :disabled="isProcessing"><a>新規作成</a></div>
      </div>
      <div class="l-contentsBox">
        <div class="l-diagnosisSearch">
          <div class="l-diagnosisSearch__header" @click="showSearch(!isSearch)">
            <p class="l-diagnosisSearch__label"><img src="@/assets/img/common/icon-search.svg" alt="">絞り込み</p>
          </div>
          <transition name="inquirysearch-fade">
            <div class="l-diagnosisSearch__body" v-show="isSearch">
              <div class="l-diagnosisSearch__section">
                <label class="l-formGroup__label">お問い合わせ元法人名</label>
                <div class="l-inputKeyword">
                  <TextBox v-model="searchForm.reqCorpName" name="searchFormReqCorpName" ></TextBox>
                </div>
              </div>
              <div class="l-diagnosisSearch__section">
                <label class="l-formGroup__label">お問い合わせ内容</label>
                <div class="l-inputKeyword">
                  <TextBox v-model="searchForm.inquiry" name="searchFormReqCorpName" ></TextBox>
                </div>
              </div>
              <div class="l-diagnosisSearch__section">
                <div class="l-formGroup">
                  <label class="l-formGroup__label">回答担当</label>
                  <label class="l-checkbox">
                    <CheckBox v-model="searchForm.isMyselfRes" :value="true" :checked="searchForm.isMySelfRes" labelText='回答担当が自社のもので絞り込む' />
                  </label>
                </div>
              </div>
              <div class="l-diagnosisSearch__bottom">
                <div class="btn-basic is-inlne" @click="getInquiryList(1)" :disabled="isProcessing"><a>絞り込む</a></div>
              </div>
            </div>
          </transition>
        </div>

        <div class="l-grayBox mt-30">
          <div class="l-infoResult">
            <p><span>検索結果：</span>{{ pageInfo.total }}件</p>
          </div>
        </div>

        <table class="table-base audit-table table-select mt-30">
          <colgroup>
            <col style="width: 80px;">
            <col style="width: 100px;">
            <col style="width: 150px;">
            <col style="width: 180px;">
            <col style="width: 150px;">
            <col style="width: 100px;">
          </colgroup>
          <thead>
            <th>受付No</th>
            <th>種別</th>
            <th>法人名</th>
            <th>お問い合わせ日時</th>
            <th>回答担当法人</th>
            <th>状態</th>
          </thead>
          <tbody>
            <tr v-for="inquiry in inquiryList" :key="inquiry.inquiryId" @click="goDetail(inquiry.inquiryId, inquiry.editable)">
              <td>{{ inquiry.inquiryId }}</td>
              <td>
                {{ inquiryKbnLabel(inquiry) }}
              </td>
              <td>
                {{ inquiry.reqCorporation.corpNm }}
              </td>
              <td>
                {{ $dayjs(inquiry.reqTs).format("YYYY/MM/DD HH:mm:ss") }}
              </td>
              <td>
                {{ inquiry.resCorporation.corpNm }}
              </td>
              <td>
                {{ inquiryStatusCdLabel(inquiry) }}
              </td>
            </tr>
          </tbody>
        </table>
        <pagination
          :pageInfo="pageInfo"
          @change-page="emitChangePage">
        </pagination>
      </div>
    </div>
  </main>
</template>

<script>
import Loading from '@/components/parts/common/Loading.vue';
import Pagination from '@/components/parts/common/Pagination.vue';
import TextBox from '@/components/parts/form/TextBox.vue';
import CheckBox from '@/components/parts/form/CheckBox.vue';
import constant from '@/const';

export default {
  components: {
    Loading,
    Pagination,
    TextBox,
    CheckBox
  },
  data() {
    return {
      pageInfo: {},
      isProcessing: false,
      isRendering: false,
      inquiryList: [],
      searchForm: {
        reqCorpName: '',
        inquiry: '',
        isMyselfRes: false,
      },
      isSearch: false,
    }
  },
  computed: {
    inquiryStatusCdLabel : () => (inquiry) => {
      let inquiryStatusCode = constant.INQUIRY_STATUS_CODE.find(function(element) {
        return element.value === inquiry.inquiryStatusCd;
      });
      return inquiryStatusCode.label;
    },
    inquiryKbnLabel : () => (inquiry) => {
      let inquiryKbn = constant.INQUIRY_KBN.find(function(element) {
        return element.value === inquiry.inquiryKbn;
      });
      return inquiryKbn.shortLabel;
    }
  },
  created: async function() {
    await this.getInquiryList(1);
  },
  methods: {
    showSearch(value) {
      this.isSearch = value;
    },
    emitChangePage(page) {
      this.getInquiryList(page)
    },
    async getInquiryList(page) {
      this.isRendering = true;
      this.isProcessing = true;
      let res = await this.$axios.post('/ld/api/inquiry/getInquiryList', {
        page: page,
        reqCorpName: this.searchForm.reqCorpName,
        inquiry: this.searchForm.inquiry,
        isMyselfRes: this.searchForm.isMyselfRes,
      });
      if (res) {
        this.inquiryList = res.data.inquiryList.data;
        this.pageInfo = {
          currentPage: res.data.inquiryList.current_page,
          lastPage: res.data.inquiryList.last_page,
          total: res.data.inquiryList.total,
          from: res.data.inquiryList.from,
          to: res.data.inquiryList.to,
        }
        this.isSearch = false;
      }
      this.$nextTick(() => {
        this.isRendering = false;
        this.isProcessing = false;
      });
    },
    goInput() {
      this.$store.dispatch('portal/setInquiryId', null);
      this.$router.push({ name: 'inquiry-new' });
    },
    goDetail(inquiryId, editable) {
      if (editable) {
        this.$store.dispatch('portal/setInquiryId', inquiryId);
        this.$router.push({ name: 'inquiry-res', query: { inquiryId: inquiryId } });
      } else {
        this.$store.dispatch('portal/setInquiryId', inquiryId);
        this.$router.push({ name: 'inquiry-detail', query: { inquiryId: inquiryId } });
      }
    },
  }
}
</script>

<style scoped>
.inquirysearch-fade-enter-active {
  transition: height .1s ease-in-out;
}
.inquirysearch-fade-leave-active {
  transition: height .1s ease-in-out;
}
.inquirysearch-fade-enter-to, .inquirysearch-fade-leave {
  overflow: hidden;
}
.inquirysearch-fade-enter, .inquirysearch-fade-leave-to {
  overflow: hidden;
}
</style>
